<template>
    <div class="toolbar-stepper">
        <div v-for="(item, i) in items" :key="i" class="ts-step"
            :class="{ active: isActive(i), done: isDone(i) }">
            <div class="ts-circle">
                <v-icon v-if="isDone(i)" size="16" color="#fff">mdi-check</v-icon>
                <template v-else>{{ i + 1 }}</template>
            </div>
            <span v-if="!noLabel" class="ts-label">{{ item }}</span>
        </div>
    </div>
</template>

<script>
export default {
    name: "ToolbarStepper",
    props: {
        step: {
            type: [Number, String],
            default: 0
        },
        items: {
            type: Array,
            default: () => []
        },
        noLabel: {
            type: Boolean,
            default: false
        }
    },
    methods: {
        isActive(index) {
            return Number(this.step) === index
        },
        isDone(index) {
            return Number(this.step) > index
        }
    }
}
</script>

<style scoped>

.toolbar-stepper {
    display: flex;
    align-items: flex-start;
    max-width: 420px;
    margin: 0 auto;
}

.ts-step {
    display: flex;
    flex-direction: column;
    align-items: center;
    position: relative;
    flex: 1;
}

.ts-step:not(:last-child)::after {
    content: '';
    position: absolute;
    top: 14px;
    left: calc(50% + 14px);
    right: calc(-50% + 14px);
    height: 1.5px;
    background: var(--v-outline-base);
    transition: background .3s ease;
}

.ts-step.done:not(:last-child)::after {
    background: var(--v-secondary-base);
}

.ts-circle {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    border: 1.5px solid var(--v-outline-base);
    background: var(--v-surface-base);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 11px;
    font-weight: 700;
    color: var(--v-txtMuted-base);
    transition: all .25s ease;
    position: relative;
    z-index: 1;
    flex-shrink: 0;
}

.ts-step.done .ts-circle {
    background: var(--v-secondary-base);
    border-color: var(--v-secondary-base);
    color: #fff;
}

.ts-step.active .ts-circle {
    background: var(--v-surface-base);
    border: 2px solid var(--v-secondary-base);
    color: var(--v-accent-base);
    box-shadow: 0 0 0 4px rgba(102, 204, 204, 0.15);
}

.ts-label {
    display: block;
    font-size: 9px;
    font-weight: 600;
    color: var(--v-txtMuted-base);
    text-transform: uppercase;
    letter-spacing: 0.04em;
    margin-top: 4px;
    text-align: center;
}

.ts-step.active .ts-label {
    color: var(--v-accent-base);
}

.ts-step.done .ts-label {
    color: var(--v-secondary-base);
}

</style>
